import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect } from "react";
import { PASTE_COMMAND, $getSelection, $isRangeSelection } from "lexical";
import { isSelectionInTable } from "../../../utils/isSelectionInTable";

export function TablePasteSanitizerPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(
    () =>
      editor.registerCommand(
        PASTE_COMMAND,
        (event: ClipboardEvent) => {
          const selection = $getSelection();
          if (!$isRangeSelection(selection)) return false;
          const isInTable = isSelectionInTable();
          if (!isInTable) return false;

          const html = event.clipboardData?.getData("text/html") ?? "";

          const forbidden = [
            "<strong",
            "<b",
            "<em",
            "<i",
            "<a ",
            "data-lexical-equation",
            "<table",
          ];

          const blocked = forbidden.some(tag => html.includes(tag));

          if (blocked) {
            event.preventDefault();
            return true;
          }

          return false;
        },
        1,
      ),
    [editor],
  );

  return null;
}
